export type ApplicationView = "all" | "customers" | "activated" | "settled" | "prospects" | "archived";
export interface ApplicationPageFilter {
  view: ApplicationView;
  page?: number;
  pageSize?: number;
  search?: string;
  status?: string | null;
  hasIssue?: boolean;
  productCategories?: string[];
  customerTypes?: string[];
  carriers?: string[];
  dealers?: string[];
  stores?: string[];
  models?: string[];
  plans?: string[];
  importSource?: string;
  sort?: "createdAt" | "activatedAt" | "stage";
  direction?: "asc" | "desc";
  dateBasis?: "createdAt" | "activatedAt";
  dateFrom?: string;
  dateTo?: string;
  createdFrom?: string;
  createdTo?: string;
  activatedFrom?: string;
  activatedTo?: string;
  unreflectedOnly?: boolean;
  ids?: number[];
  metadata?: boolean;
  metadataOnly?: boolean;
}
export interface ApplicationPageMeta {
  total: number;
  page: number;
  pageSize: number;
  facets: Record<string, Record<string, number>>;
  options: Record<string, { value: string; label: string }[]>;
  hover: Record<string, { customerId: number; name: string; phone: string }[]>;
  rosterSummary: string | null;
  unreflectedCount: number;
}
export function applicationPageParams(filter: ApplicationPageFilter): URLSearchParams {
  const query = new URLSearchParams({ view: filter.view, page: String(filter.page ?? 0), pageSize: String(filter.pageSize ?? 50) });
  for (const [key, value] of Object.entries(filter)) {
    if (value === undefined || value === null || value === "") continue;
    query.set(key, Array.isArray(value) ? value.join(",") : String(value));
  }
  return query;
}
